import type { EventTypeView } from '@ps/isp-web-services-types';
import type { Selector } from 'react-redux';
import { createSelector } from 'reselect';

import type { RootState } from '@swf/core/store';
import { withEventBasedMarketTemplateModelSelectors } from '@swf/sports/models/market-templates/eventBased';

import { defaultState } from './defaultState';
import type { HomeInPlayTabWithSlug, SportsHomeInPlayState } from './types';

export const selectors = withEventBasedMarketTemplateModelSelectors(defaultState, (slice) => ({
  tabs: () => slice((state) => state.tabs),
  error: () => slice((state) => state.error),
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isLoading),
  selectedEventType: () => slice((state) => state.selectedEventType),
  tabsWithEventTypeSlugs: () =>
    slice((state) =>
      state.tabs.map((tab) => {
        const eventTypeView = state.eventTypes[tab.eventTypeId] as EventTypeView;
        return {
          ...tab,
          eventTypeSlug: eventTypeView.eventTypeSlug
        };
      })
    ),
  selectedTab(this: {
    tabsWithEventTypeSlugs: Selector<RootState, HomeInPlayTabWithSlug[]>;
    selectedEventType: Selector<RootState, SportsHomeInPlayState['selectedEventType']>;
  }) {
    return createSelector(
      this.tabsWithEventTypeSlugs,
      this.selectedEventType,
      (tabs, selectedEventType): HomeInPlayTabWithSlug | undefined =>
        tabs.find((tab) => tab.eventTypeId === selectedEventType) ?? tabs[0]
    );
  }
}));
